(function() {

  angular
  .module('meanApp')
  .factory('Model', Model);

  Model.$inject = ['$http', 'httpAuth', '$window', '$q', '$rootScope', 'authentication'];
  function Model ($http, httpAuth, $window, $q, $rootScope, authentication) {
    var Model = function (data) {
    	if(data) {
    		this.setData(data);
    	}
    };
    Model.prototype = {
    	setData: function(data) {
            if(this.setDataOverrided) {
                this.setDataOverrided(data);
            }
            else {
                angular.extend(this, data);
            }
        },
        save: function() { //if fd this is the priority
            var deferred = $q.defer();
            httpAuth.post("/api/" + this.getAPIPath() + "/", this, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(instance) {
                this.setData(instance);
                deferred.resolve(instance);
            }.bind(this))
            .error(function(err) {
                console.log("JS front end error for creating new measure");
                deferred.reject(err);
            });

            return deferred.promise;
        },
        update: function(data, updateFromServer) {
            var deferred = $q.defer();
            httpAuth.put("/api/" + this.getAPIPath() + "/" + this._id, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(data) {
                console.log("JS front end success for updating"); 
                if(typeof updateFromServer !== 'undefined' && updateFromServer !== false) {
                     this.setData(data); 
                }
                deferred.resolve(data);
            }.bind(this))
            .error(function(err) {
                console.log("JS front end error for updating"); 
                deferred.reject(err);
            });
            return deferred.promise;
        }
    };

    return Model;
  };
})();










/**! function() {
    function t(t, e, n, o, r, i) {
        var s = function(t) {
            t && this.setData(t)
        };
        return s.prototype = {
            setData: function(t) {
                angular.extend(this, t)
            },
            save: function() {
                var t = o.defer();
                return e.post("/api/" + this.getAPIPath() + "/", this, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).success(function(e) {
                    this.setData(e), t.resolve(e)
                }.bind(this)).error(function(e) {
                    console.log("JS front end error for creating new measure"), t.reject(e)
                }), t.promise
            },
            update: function(t) {
                var n = o.defer();
                return e.put("/api/" + this.getAPIPath() + "/" + this._id, t, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).success(function(t) {
                    console.log("JS front end success for updating"), this.setData(t), n.resolve(t)
                }.bind(this)).error(function(t) {
                    console.log("JS front end error for updating"), n.reject(t)
                }), n.promise
            }
        }, s
    }
    angular.module("meanApp").factory("Model", t), t.$inject = ["$http", "httpAuth", "$window", "$q", "$rootScope", "authentication"]
}();**/